<template>
  <div id="additionalInformation">
    <h3 class="mb-5 tracking-wide md:mb-4 md:text-[22px] md:text-xl">Additional Information</h3>
    <!-- 予約質問の一覧は新動線の S3（HostDetailsSection）と共有する。新動線は見出しをアコーディオン側が出すので、見出しだけここに持つ -->
    <ReservationQuestionFields :get-error-message="getErrorMessage" />
  </div>
</template>

<script setup lang="ts">
import ReservationQuestionFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/ReservationQuestionFields/ReservationQuestionFields.vue';

interface Props {
  getErrorMessage: (s: string) => string;
}

defineProps<Props>();
</script>
